import { APIReportFilters, ArdoqId } from '@ardoq/api-types';
import {
  copyReportInDiscoverURL,
  EnhancedSearchResponse,
  ExportButtonCommands,
  ReportEventLocations,
  ReportReaderLocation,
  searchResultsOperations,
  trackCopyReportURL,
} from '@ardoq/report-reader';
import { exportToJSON } from '../utils';
import { Maybe } from '@ardoq/common-helpers';
import { dispatchAction } from '@ardoq/rxbeach';
import {
  copyReportUrlWithStateIdButtonWasClicked,
  exportToExcelButtonWasClicked,
  exportToReadableExcelButtonWasClicked,
} from '../actions';
import { CopyReportUrLParams } from '../../types';
import { trackEvent } from 'tracking/tracking';
import { isEmpty } from 'lodash';
import { CopyEntityURLButtonCommands } from '@ardoq/snowflakes';

const getReportName = (searchResults: Maybe<EnhancedSearchResponse>) =>
  searchResults ? searchResultsOperations.getName(searchResults) : 'Report';

const getExportToReadableExcel =
  (
    id: ArdoqId,
    reportName: string,
    filters: APIReportFilters | null
  ): VoidFunction =>
  () => {
    dispatchAction(
      exportToReadableExcelButtonWasClicked({
        id,
        filters,
        reportName,
      })
    );
  };

const getExportToExcel =
  (
    id: ArdoqId,
    reportName: string,
    filters: APIReportFilters | null
  ): VoidFunction =>
  () => {
    dispatchAction(
      exportToExcelButtonWasClicked({
        id,
        filters,
        reportName,
      })
    );
  };

export const getExportButtonCommands = (
  id: ArdoqId,
  searchResults: Maybe<EnhancedSearchResponse>,
  filters: APIReportFilters | null
): ExportButtonCommands => {
  const reportName = getReportName(searchResults);
  return {
    exportToReadableExcel: getExportToReadableExcel(id, reportName, filters),
    exportToExcel: getExportToExcel(id, reportName, filters),
    exportToJSON: () => exportToJSON(id),
  };
};

export const getCopyReportUrlButtonCommands = (
  payload: CopyReportUrLParams,
  eventLocation: ReportReaderLocation
): CopyEntityURLButtonCommands => ({
  copyArdoqEntityUrl: () => {
    dispatchAction(copyReportUrlWithStateIdButtonWasClicked(payload));
    trackCopyReportURL(
      trackEvent,
      eventLocation,
      ReportEventLocations.DISCOVER,
      !isEmpty(payload.filters)
    );
  },
  copyDiscoverEntityUrl: () => {
    copyReportInDiscoverURL(payload.id);
    trackCopyReportURL(
      trackEvent,
      eventLocation,
      ReportEventLocations.DISCOVER
    );
  },
});
